import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Button from 'components/CustomButtons/Button';
import MenuItem from '@material-ui/core/MenuItem';

import {
  getNextStatuses,
  statusOptions,
  updateInvoiceStatus,
} from 'services/invoice';

import { ConsoleContext } from 'services/context';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
}));

export default function ChangeStatusDialog({
  open, invoice, onClose, onSave,
}) {
  const classes = useStyles();

  const { showError, showSuccess, t } = useContext(ConsoleContext);

  const [openDialog, setOpenDialog] = useState(open);

  const [status, setStatus] = useState('');

  const [payedAmount, setPayedAmount] = useState('');

  const nextStatuses = getNextStatuses(invoice.status);

  const options = statusOptions.filter((option) => nextStatuses.indexOf(option.id) > -1);

  useEffect(() => {
    setStatus('');
    setOpenDialog(open);
  }, [open]);

  const handleChangeStatus = (value) => {
    setStatus(value);
  };

  const handleCloseDialog = () => {
    onClose();
  };

  const handlePayedAmountChange = (amount) => {
    setPayedAmount(amount);
  };

  const handleSubmit = async () => {
    const data = {
      _id: invoice._id,
      status,
    };

    if (status === 'completed') {
      data.payedAmount = payedAmount;
    }

    try {
      const savedInvoice = await updateInvoiceStatus(data);

      showSuccess('Status changed');
      setStatus('');
      onSave(savedInvoice);
    } catch (e) {
      showError(e);
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={openDialog}
      onClose={handleCloseDialog}
    >
      <DialogTitle>{t('Change Status')}</DialogTitle>
      <DialogContent>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl className={classes.formControl}>
              <InputLabel>
                {t('Status')}
                {' '}
                *
              </InputLabel>
              <Select
                fullWidth
                value={status}
                onChange={(e) => handleChangeStatus(e.target.value)}
              >
                { options.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    { t(option.name) }
                  </MenuItem>
                )) }
              </Select>
            </FormControl>
          </GridItem>
          { status === 'completed' ? (
            <GridItem xs={12} sm={12} md={6}>
              <TextField
                required
                fullWidth
                value={payedAmount}
                label={`${t('Payed Amount')}, ${invoice.currency}`}
                onChange={(e) => handlePayedAmountChange(e.target.value)}
              />
            </GridItem>
          ) : null }
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>
          {t('Cancel')}
        </Button>
        <Button onClick={handleSubmit} color="primary">
          {t('Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
